import React from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {LoadMore} from 'react-weui'
import ChimeePlayer from 'chimee-player';
import {TimeStream} from '../../utils';
import config from '../../config'
import '../../styles/classroom/ClassroomTopVideo.css';
import '../../styles/chimee/ChimeeVideo.css';
import '../../styles/chimee/ChimeeMenu.css';
import '../../styles/chimee/ChimeeCenterState.css';
import tips_icon from '../../images/tips-icon.png';


class ClassroomTopVideo extends React.PureComponent {
    state = {
        posterUrl: null,
        videoUrl: null,
        videoInfo: null,
        loading: false,
    }

    componentDidMount() {
        const {lecture} = this.props
        const fileId = lecture.qcloud_video_file_id

        if (fileId) {
            this.setState({loading: true})
            axios.get(`/api/bridge/qcvideo/${fileId}`).then((response) => {
                if (response.data.code === 0) {
                    const {data} = response.data.data

                    if (data.file_info.status !== "2") {
                        this.setState({videoInfo: data, loading: false})
                        return
                    }

                    const posterUrl = data.file_info.image_url;
                    const video = data.file_info.image_video.videoUrls.pop();
                    this.setState({posterUrl: posterUrl, videoUrl: video.url, videoInfo: data, loading: false});

                    // 安卓和pc端加载新的视频播放器
                    let elem = document.getElementById('chimee-container')
                    if (window.systemType !== 'ios' && window.systemType !== 'android' && elem) {
                        let chimeeOptions = {
                            wrapper: '#chimee-container',
                            src: video.url,
                            isLive: false,
                            box: 'native',
                            poster: posterUrl,
                            autoplay: false,
                            controls: true,
                            xWebkitAirplay: true
                        }
                        let player = new ChimeePlayer(chimeeOptions)
                        player.on('play', this.onPlay.bind(this))
                        player.on('pause', this.onPause.bind(this))
                        player.on('ended', this.onEnded.bind(this))
                    }
                }
            }).catch((error) => {
                console.log(error);
            })
        }
    }

    onPlay() {
        this.props.dispatch({
            type: 'TOP_VIDEO_PLAY'
        })
    }

    onPause() {
        this.props.dispatch({
            type: 'TOP_VIDEO_PAUSE'
        })
    }

    onEnded() {
        this.props.dispatch({
            type: 'TOP_VIDEO_ENDED'
        })
    }

    componentDidUpdate() {
        const {audioState} = this.props
        const topVideo = document.getElementById('top_video')
        if (audioState === 'playing' && topVideo && !topVideo.paused) {
            topVideo.pause()
        }
    }

    render() {
        const {showTopVideo, role, lecture, isLectureBegin} = this.props
        const {videoInfo, loading} = this.state
        const clientWidth = Math.min(480, window.innerWidth || screen.width)
        const videoHeight = showTopVideo ? Math.ceil(clientWidth * 1080 / 1920) : 0

        if (loading) {
            return <div id="wk-video" className={"classroom-top-video " + (window.platform === 'pc' ? 'pc-video' : '')}
                        style={{height: videoHeight, display: showTopVideo ? 'block' : 'none'}}>
                <div className="classroom-no-video">
                    <LoadMore loading/>
                </div>
            </div>
        }

        return (<div id="wk-video" className={"classroom-top-video " + (window.platform === 'pc' ? 'pc-video' : '')}
                     style={{height: videoHeight, display: showTopVideo ? 'block' : 'none'}}>
            {(!isLectureBegin && showTopVideo && !(role.is_lecturer || role.is_manager)) ?
                <div className="classroom-no-video" style={{fontSize: '16px'}}>
                    <p><img src={tips_icon} style={{width: "50%"}} alt="tips_icon"/></p>
                    <p>开课时间: {TimeStream(lecture.start_timestamp, 'MD_HM')}</p>
                    <p>敬请期待</p>
                </div>
                :
                this.state.videoUrl ?
                    <div style={{display: 'inline'}}>
                        {(window.systemType !== 'ios' && window.systemType !== 'android') ?
                            <div id="chimee-container" className="chimee-container"
                                 style={{height: videoHeight, width: '100%'}}>
                                <video tabIndex="-1" id="top_video" />
                            </div>
                            :
                            <video is
                                   ref="topVideo"
                                   id="top_video"
                                   controls
                                   controlsList="nodownload"
                                   playsinline="true"
                                   webkit-playsinline=""
                                   x-webkit-airplay="true"
                                   preload="load"
                                   poster={this.state.posterUrl}
                                   src={this.state.videoUrl}
                                   onPlay={this.onPlay.bind(this)}
                                   onPause={this.onPause.bind(this)}
                                   onEnded={this.onEnded.bind(this)}
                                   x5-playsinline=""/>
                        }
                    </div>
                    :
                    role.is_lecturer ?
                        (videoInfo && videoInfo.file_info.status !== '2' ?
                                <div className="classroom-no-video">
                                    视频正在处理中....
                                </div>
                                :
                                <div className="classroom-no-video" style={{width:'200px'}}>
                                    <p>尚未上传视频</p>
                                    <p style={{marginTop: '10px'}}>请登录讲师管理后台-课程管理操作上传</p>
                                    {['ios', 'android'].indexOf(window.systemType) > -1 ?
                                        <p>({config.ADMIN_BASE_URL}/lecture/)</p>
                                        :
                                        <p>(<a className="wk-link" href={`${config.ADMIN_BASE_URL}/lecture/`}
                                               target="_blank">{config.ADMIN_BASE_URL}/lecture/</a>)
                                        </p>
                                    }
                                </div>
                        )
                        :
                        <div className="classroom-no-video">
                            暂无可播放的视频文件
                        </div>
            }
        </div>);
    }
}


export default connect((state) => ({
    showTopVideo: state.classroom.showTopVideo,
    audioState: state.audioPlayer.audioState,
    lecture: state.classroom.lecture,
    role: state.classroom.role,
}))(ClassroomTopVideo)





// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomTopVideo.js